module.exports = __webpack_public_path__ + "assets/7d138c4c8713f38cd4a6b8d31f4b9a84.svg";